@if (isEmpty()) {
    <div class="media">
        <fui-icon [height]="24" [icon]="'lock'" [width]="24"></fui-icon>
    </div>
}
@for (pin of value; track pin; let index = $index) {
    <fui-pin id="{{index}}-pin"></fui-pin>
}
